// extracted by mini-css-extract-plugin
export default {"container":"TransactionInfo_container__NmA9F","link":"TransactionInfo_link__E4kic","icon":"TransactionInfo_icon__yFNIT","btn":"TransactionInfo_btn__2OAH1"};